import pauseCircleIcon from '../../assets/leads/pauseCircle.png';
import rescheduleIcon from '../../assets/leads/reschedule.png';
import playIcon from '../../assets/leads/play.png';
import pauseButtonIcon from '../../assets/leads/pauseButton.png';
import { getReminderActionButtons, isFollowUpReminder } from '../utils';

const ACTION_META = {
  stop: {
    label: 'Stop',
    icon: pauseCircleIcon,
    hoverClass: 'hover:bg-yellow-500/10',
  },
  reschedule: {
    label: 'Reschedule',
    icon: rescheduleIcon,
    hoverClass: 'hover:bg-purple-500/10',
  },
  pause: {
    label: 'Pause',
    icon: pauseButtonIcon,
    hoverClass: 'hover:bg-green-500/10',
  },
  resume: {
    label: 'Resume',
    icon: playIcon,
    hoverClass: 'hover:bg-green-500/10',
  },
};

export function ReminderRowActions({
  reminder,
  canUpdate = true,
  disabled = false,
  onAction,
}) {
  if (!isFollowUpReminder(reminder)) return null;

  if (!canUpdate) return null;

  const actions = getReminderActionButtons(reminder);
  if (!actions.length) return null;

  return (
    <div
      className="flex items-center justify-end gap-1"
      onClick={(e) => e.stopPropagation()}
    >
      {actions.map((action) => {
        const meta = ACTION_META[action];
        if (!meta) return null;
        return (
          <button
            key={action}
            type="button"
            title={meta.label}
            aria-label={meta.label}
            disabled={disabled}
            onClick={() => onAction?.({ type: action, reminder })}
            className={`w-9 h-9 shrink-0 flex items-center justify-center rounded-lg ${meta.hoverClass} transition-colors focus:outline-none disabled:opacity-50`}
          >
            <img
              src={meta.icon}
              alt=""
              className="w-5 h-5 object-contain shrink-0"
            />
          </button>
        );
      })}
    </div>
  );
}
